import './../../scss/theme/components/page-teaser-slider.scss';

window.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelectorAll('.page-teaser-slider');

    if (slider.length) {
        slider.forEach((item) => {
            const textSlider = item.querySelector('.text-swiper');
            const textSliderPagination = item.querySelector('.swiper-pagination');
            const textSliderPrev = item.querySelector('.swiper-button-next');
            const textSliderNext = item.querySelector('.swiper-button-prev');
            const imgSlider = item.querySelector('.img-swiper');

            var slidesPerView = 2.2; // Must be the same as imgSwiper to share controlls. We hide the additional slides for text

            let textSwiper = new Swiper(textSlider, {
                slidesPerView: 1,
                autoHeight: false,
                effect: 'fade',
                grabCursor: true,
                loop: true,
                speed: 500,
                //speed: 227.27, //500sp / 2.2 slides

                //watchSlidesProgress: true,
                slideToClickedSlide: true,
                fadeEffect: {
                    crossFade: true
                },
                //freeMode: true,
                spaceBetween: 40,
                breakpoints: {
                    834: {
                        slidesPerView: slidesPerView,
                    }
                },
                pagination: {
                    el: textSliderPagination,
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: textSliderPrev,
                    prevEl: textSliderNext,
                },
            });

            let imgSwiper = new Swiper(imgSlider, {
                slidesPerView: 1,
                autoHeight: false,
                effect: 'slide',
                grabCursor: true,
                loop: true,
                speed: 500,
                spaceBetween: 40,
                breakpoints: {
                    834: {
                        slidesPerView: slidesPerView,
                    }
                }
            });

            // Syncs controller for each swiper (Avoid solution via thumbs)
            textSwiper.controller.control = imgSwiper;
            imgSwiper.controller.control = textSwiper;
        });
    }
});
